// Tour step properties:
//   - aboveDrawer: (bool) step targets an element inside a drawer overlay — adjusts z-index accordingly
//   - awaitClick: (string) CSS selector — the tour pauses until the user clicks this element
//   - awaitClickAdvanceDelay: (number) ms to wait after the click before moving to the next step
//   - awaitClickAll: (bool) listen for click on ALL elements matching awaitClick, not just the first
//   - awaitClickDelegate: (bool) use event delegation for awaitClick — resilient to DOM re-renders (e.g. FullCalendar)
//   - awaitClickLast: (bool) target the last matching element and block clicks on all others
//   - blockClickOnlySelectors: (string[]) CSS selectors whose click events are blocked (mousedown allowed for drag-and-drop)
//   - blockClickSelectors: (string[]) CSS selectors whose click AND mousedown events are blocked
//   - blockOutsideSpotlight: (bool) block all clicks outside the spotlight area (overlay captures pointer events)
//   - blockTarget: (bool|string) true = block clicks on the spotlight target; string = block clicks on that selector
//   - blockTargetException: (string|string[]) inside a blocked target, these selectors stay clickable
//   - blockTargetSiblings: (bool) block all siblings inside the target container, only the awaitClick element stays clickable
//   - clickBeforeNextIf: (object|object[]) one or more { selector, containsText?, clickSelector?, delayAfter? } — before advancing, for each item: click the element (or clickSelector) if selector’s text includes containsText (or always if omitted)
//   - clickBeforePrevIf: (object|object[]) same as clickBeforeNextIf but fires when user clicks “Précédent”
//   - congrats: (bool) marks the final congratulatory step (triggers confetti)
//   - content: (string) i18n key for the step body text
//   - hideFinish: (bool) hide the Finish button (used when chaining to another tour)
//   - hidePrev: (bool) hide the Previous button for this step
//   - highlightDays: (bool) add a pulsing highlight to calendar day cells
//   - nextTour: (string) id of the tour to start when this step or tour ends (chaining)
//   - noSpotlight: (bool) disable the spotlight cutout (full overlay, e.g. for congrats)
//   - position: (string) tooltip placement relative to the target — top | bottom | left | right | center
//   - pulse: (bool) show a pulsing animation on the awaitClick element (default: true when awaitClick is set)
//   - raiseAncestors: (bool) raise ancestor stacking contexts so the target escapes its parent z-index
//   - scrollTo: (string) 'top' scrolls the page to top instead of centering the target
//   - spotlightPadding: (number|object) extra px around the target — number for uniform, object { top, right, bottom, left } for per-side
//   - target: (string) CSS selector of the element to highlight
//   - title: (string) i18n key for the step title
//   - watchTargets: (string[]) extra CSS selectors included in the spotlight area

export default {
  id: 'planner',
  route: 'posts2',
  steps: [
    // --- Step 1: Overview of the planner ---
    {
      target: '.section-posts2',
      title: 'tours.planner.steps.overview.title',
      content: 'tours.planner.steps.overview.content',
      position: 'center',
      spotlightPadding: 0,
      blockTarget: true,
      blockOutsideSpotlight: true
    },
    // --- Step 2: Page selector sidebar ---
    {
      target: '.select-page-section',
      title: 'tours.planner.steps.selectPage.title',
      content: 'tours.planner.steps.selectPage.content',
      position: 'right',
      blockTarget: '.btns-action',
      blockClickSelectors: ['.day-cell'],
      blockOutsideSpotlight: true
    },
    // --- Step 3: Date navigation ---
    {
      target: '.navigation-date',
      title: 'tours.planner.steps.dateNav.title',
      content: 'tours.planner.steps.dateNav.content',
      position: 'bottom',
      blockClickSelectors: ['.day-cell'],
      blockOutsideSpotlight: true
    },
    // --- Step 4: Filters ---
    {
      target: '.navigation-filter',
      title: 'tours.planner.steps.filters.title',
      content: 'tours.planner.steps.filters.content',
      position: 'bottom',
      watchTargets: ['.post-filter', '.container-context-menu'],
      blockOutsideSpotlight: true
    },
    // --- Step 5: View tabs (calendar / list) ---
    {
      target: '.navigation-main',
      title: 'tours.planner.steps.viewTabs.title',
      content: 'tours.planner.steps.viewTabs.content',
      position: 'bottom',
      spotlightPadding: 13,
      // Before advancing or going back, ensure the calendar is in Month view:
      // 1. If active tab is "Liste", click the planner tab (2nd .icon-l)
      // 2. If active tab is "Feed", click the planner tab (2nd .icon-l)
      // 3. If active tab shows "Semaine", click it to toggle to Mois
      clickBeforeNextIf: [
        { selector: '.navigation-main .icon-l.btn-primary', containsText: 'Liste', clickSelector: '.navigation-main .icon-l:nth-child(2)', delayAfter: 350 },
        { selector: '.navigation-main .icon-l.btn-primary', containsText: 'Feed', clickSelector: '.navigation-main .icon-l:nth-child(2)', delayAfter: 350 },
        { selector: '.navigation-main .icon-l.btn-primary', containsText: 'Semaine', delayAfter: 0 }
      ],
      clickBeforePrevIf: [
        { selector: '.navigation-main .icon-l.btn-primary', containsText: 'Liste', clickSelector: '.navigation-main .icon-l:nth-child(2)', delayAfter: 350 },
        { selector: '.navigation-main .icon-l.btn-primary', containsText: 'Feed', clickSelector: '.navigation-main .icon-l:nth-child(2)', delayAfter: 350 },
        { selector: '.navigation-main .icon-l.btn-primary', containsText: 'Semaine', delayAfter: 0 }
      ],
      blockOutsideSpotlight: true
    },
    // --- Step 6: Click a day to create a post (chains to postCreator) ---
    {
      target: '.days-cells',
      title: 'tours.planner.steps.createPost.title',
      content: 'tours.planner.steps.createPost.content',
      position: 'left',
      spotlightPadding: 4,
      nextTour: 'postCreator',
      hideFinish: true,
      highlightDays: true,
      blockOutsideSpotlight: true
    }
  ]
}
